import { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'

const TermsOfService = ({ className }: { className?: string }) => {
  const [content, setContent] = useState('')

  useEffect(() => {
    fetch('/termsOfService/termsOfService.md')
      .then(res => res.text())
      .then(text => {
        return setContent(text)
      })
  }, [])

  return (
    <div>
      <div className={`flex flex-1 justify-center ${className}`}>
        <strong> Terms of Services</strong>
      </div>
      <ReactMarkdown className={`text-justify markdown ${className}`}>
        {content}
      </ReactMarkdown>
    </div>
  )
}
export default TermsOfService
